import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const RollyEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);

		return () => {
			window.removeEventListener('mousemove', mouseMove);
			gsap.killTweensOf('.rollyEyes-e');
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -8;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.rollyEyes-e');
		gsap.to('.rollyEyes-e', { duration: 0.5, x, y });
	}, []);

	return (
		<svg
			className='rollyEyes svg-max'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 133.29 167.63'>
			<circle
				className='fill'
				cx='66.65'
				cy='66.65'
				r='66.64'
			/>
			<path
				className='defaultStyle'
				d='M51.92,126.46c-.45,5-1.45,18.64-2.17,27.27A10.9,10.9,0,0,1,42,163.28l-4.73,1.4'
			/>
			<path
				className='defaultStyle'
				d='M79.1,127.9c.46,5,1.45,18.65,2.17,27.27A10.91,10.91,0,0,0,89,164.72l4.72,1.41'
			/>
			<path
				className='rollyEyes-e fillWhite'
				d='M57.75,53.62l0,3.51L45,57l0-3.51Z'
			/>
			<path
				className='rollyEyes-e fillWhite'
				d='M87,54l0,3.51-12.75-.13,0-3.51Z'
			/>
		</svg>
	);
});

export default RollyEyes;
